module.exports = "<div class=\"bitcoinPriceContainer\">\n  Bitcoin:\n  <div class=\"bitcoinPrice\">\n\n  </div>\n  +20%\n</div>\n"